export default {
  BASE_URL: '',
  api: [
    {
      name: 'add',
      method: 'POST',
      desc: '添加购物车',
      path: '//car/addCart'
    },
    {
      name: 'cartInfo',
      method: 'GET',
      desc: '获取购物车信息',
      path: '//car/cartInfo',
      mock: false
    },
    {
      name: 'orderInfo',
      method: 'GET',
      desc: '获取订单信息',
      path: '//car/orderInfo',
      mock: false
    },
    {
      name: 'delCart',
      method: 'DELETE',
      desc: '删除购物车信息',
      path: '//car/delCart',
      mock: false,
      params: {
        id: ''
      }
    },
    {
      name: 'updateNum',
      method: 'PUT',
      desc: '更新商品数量',
      path: '//car/updateNum',
      mock: false
    },
    {
      name: 'createOrder',
      method: 'POST',
      desc: '提交订单',
      path: '//order/createOrder',
      mock: false
    },
    {
      name: 'list',
      method: 'GET',
      desc: '获取订单列表',
      path: '//order/list',
      mock: false
    },
    {
      name: 'billStatus',
      method: 'GET',
      desc: '获取订单状态',
      path: '//order/billStatus',
      mock: false
    },
    {
      name: 'changeStatus',
      method: 'PUT',
      desc: '取消订单/采购商确认订单/删除订单',
      path: '//order/changeStatus',
      mock: false
    },
    {
      name: 'purConfirm',
      method: 'PUT',
      desc: '采购商确认订单',
      path: '/order/purConfirm',
      mock: false
    },
    {
      name: 'urgeBill',
      method: 'POST',
      desc: '催单',
      path: '//order/urgeBill',
      mock: false
    },
    {
      name: 'detail',
      method: 'GET',
      desc: '订单详情',
      path: '//order/detail',
      mock: false
    },
    {
      name: 'renewBuy',
      method: 'POST',
      desc: '重新购买',
      path: '//order/renewBuy',
      mock: false
    },
    {
      name: 'cancelReason',
      method: 'GET',
      desc: '取消原因',
      path: '//order/cancelReason',
      mock: false
    },
    {
      name: 'addressInfo',
      method: 'GET',
      desc: '获取地址信息',
      path: '//contacts/addressInfo',
      mock: false
    },
    {
      name: 'projInfo',
      method: 'GET',
      desc: '获取项目信息',
      path: '//crmProject/projInfo',
      mock: false
    },
    {
      name: 'number',
      method: 'GET',
      desc: '获取购物车数量',
      path: '//car/number'
    },
    {
      name: 'signDetail',
      method: 'GET',
      desc: '获取签收单详情',
      mock: false,
      path: '/order/signDel'
    },
    {
      name: 'subSign',
      method: 'POST',
      desc: '提交签收单',
      mock: false,
      path: '/order/subSign'
    },
    {
      name: 'payMethod',
      method: 'GET',
      desc: '获取项目结算方式',
      path: 'car/payMethod',
      params: {}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/me-center/cart.js